import {
  BankOutlined,
  ExclamationCircleOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { FC } from 'react';

interface IPodSummaryPanelProps {
  clinicsSelected: number;
  patients: number;
  maAssigned: number;
  maSuggested: number;
  rnAssigned: number;
  rnSuggested: number;
}

const PodSummaryPanel: FC<IPodSummaryPanelProps> = ({
  clinicsSelected,
  patients,
  maAssigned,
  maSuggested,
  rnAssigned,
  rnSuggested,
}) => {
  const { t } = useTranslation();

  return (
    <div className={s.panel} data-cy="pod-summary-panel">
      <div className={s.capacitySection}>
        <div className={s.sectionTitle}>{t('labels.panelCapacity')}</div>
        <div className={s.capacityItem}>
          <div className={s.capacityIcon}>
            <BankOutlined />
          </div>
          <div className={s.capacityInfo}>
            <span className={s.capacityLabel}>
              {t('labels.clinicsSelected')}
            </span>
            <span
              className={s.capacityValue}
              role="status"
              aria-live="polite"
              data-cy="clinics-selected-value"
            >
              {clinicsSelected}
            </span>
          </div>
        </div>
        <div className={s.capacityItem}>
          <div className={s.capacityIcon}>
            <TeamOutlined />
          </div>
          <div className={s.capacityInfo}>
            <span className={s.capacityLabel}>{t('labels.patients')}</span>
            <span
              className={s.capacityValue}
              role="status"
              aria-live="polite"
              data-cy="patients-value"
            >
              {patients}
            </span>
          </div>
        </div>
      </div>
      <div className={s.staffingSection}>
        <div className={s.sectionTitle}>{t('labels.suggestedStaffing')}</div>
        <div className={s.staffingRow}>
          <span className={s.staffingLabel}>MA</span>
          <div className={s.staffingStatus}>
            <span>
              {maAssigned} / {maSuggested}
            </span>
            <ExclamationCircleOutlined className={s.staffingIcon} />
          </div>
        </div>
        <div className={s.staffingRow}>
          <span className={s.staffingLabel}>RN</span>
          <div className={s.staffingStatus}>
            <span>
              {rnAssigned} / {rnSuggested}
            </span>
            <ExclamationCircleOutlined className={s.staffingIcon} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PodSummaryPanel;
